import { sass } from "../../sass/sass.js";
import { MILLISECONDS_PER_SECOND } from "../../utils/constants.time.js";
class ToastMaster extends EventTarget {
  constructor(options = {}) {
    super(), this._defaultExpiryMs = options.defaultExpiryMs || 10 * MILLISECONDS_PER_SECOND, this._removalMs = options.removalMs || sass.motion.flash.duration.medium[4] * MILLISECONDS_PER_SECOND, this._maxVisible = options.maxVisible || 2, this._toasts = [];
  }
  get toasts() {
    return [...this._toasts];
  }
  /**
   * Adds a toast and initiates the timer to expire it
   *
   * - Automatically generates a `toastId` if one is not already present
   */
  addToast(toast) {
    const props = {
      ...toast.props,
      toastId: toast.props.toastId || window.crypto.randomUUID()
    }, fullToast = { ...toast, props };
    this._toasts.push(fullToast), this.toasts.length > this._maxVisible && this.toasts.slice(0, -this._maxVisible).forEach((t) => {
      this.expireToast(t.props.toastId);
    });
    const expiryMs = toast.expiryMs ?? this._defaultExpiryMs, timeout = setTimeout(() => {
      this.expireToast(props.toastId), clearTimeout(timeout);
    }, expiryMs);
    return this.dispatchEvent(new ToastsUpdatedEvent(this.toasts)), fullToast;
  }
  /**
   * Sets a toast to expired, then removes it after a short time to allow for any
   *   removal animations to complete
   */
  expireToast(toastId) {
    const expiredToastMatch = this._toasts.find((t) => t.props.toastId === toastId);
    expiredToastMatch && (expiredToastMatch.props.isExpired = !0), this.dispatchEvent(new ToastsUpdatedEvent(this.toasts));
    const timeout = setTimeout(() => {
      this.removeToast(toastId), clearTimeout(timeout);
    }, this._removalMs);
  }
  removeToast(toastId) {
    this._toasts = this._toasts.filter((t) => t.props.toastId !== toastId), this.dispatchEvent(new ToastsUpdatedEvent(this.toasts));
  }
}
const _ToastsUpdatedEvent = class _ToastsUpdatedEvent2 extends CustomEvent {
  constructor(toasts) {
    super(_ToastsUpdatedEvent2.type, { detail: toasts });
  }
};
_ToastsUpdatedEvent.type = "toasts-updated";
let ToastsUpdatedEvent = _ToastsUpdatedEvent;
export {
  ToastMaster,
  ToastsUpdatedEvent
};
//# sourceMappingURL=ToastMaster.js.map
